/* eslint-disable */
// because legacy

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'bootstrap/js/dropdown'
import 'bootstrap/js/tooltip'
import 'bootstrap/js/popover'
import 'bootstrap/js/collapse'
import "jquery-match-height"

import '@bikemap/js/legacy/utils'
import '@bikemap/js/legacy/forms'

import {
    Storage,
    STORAGE_KEY_CONVERSION_BANNER_HIDDEN,
    STORAGE_KEY_PREMIUM_CONVERSION_BANNER_HIDDEN,
} from '@bikemap/js/utility'
import initGlobal, { initPageFooter, initPageHeader } from '@bikemap/js/integrations/global'
import { user } from './services'
import { fetchRouteItemsFavoriteState, initRouteItems } from './integrations/routes'
import sessionData from './services/sessionData'

initGlobal()
initPageHeader()
initPageFooter()

$(function() {
  "use strict"

  user.getIsPremium().then(function(isPremium) {
    var bannerOffset = 1

    var conversionBanner

    var showConversionBannerOnScroll = function() {
      if (
        sessionStorage.getItem("showConversionBanner") === "true" ||
        $(this).scrollTop() > bannerOffset
      ) {
        conversionBanner.removeClass("invisible")
        conversionBanner.addClass("fob-is-visible")
        sessionStorage.setItem("showConversionBanner", "true")
      }
    }

    sessionData.isLoggedIn().then(isLoggedIn => {
      if (isLoggedIn) {
        if (
          !isPremium &&
          !Storage.getItem(STORAGE_KEY_PREMIUM_CONVERSION_BANNER_HIDDEN, true)
        ) {
          conversionBanner = $("#fob-premium")

          if (sessionStorage.getItem("showConversionBanner") === "true") {
            showConversionBannerOnScroll()
          } else {
            $(window).on("scroll", showConversionBannerOnScroll)
          }

          $(".js-close", conversionBanner).on("click", function() {
            conversionBanner.removeClass("fob-is-visible")
            sessionStorage.removeItem("showConversionBanner")
            $(window).off("scroll", showConversionBannerOnScroll)
            Storage.setItem(STORAGE_KEY_PREMIUM_CONVERSION_BANNER_HIDDEN, 'true', true)
          })
        }
      } else if (!Storage.getItem(STORAGE_KEY_CONVERSION_BANNER_HIDDEN, true)) {
        conversionBanner = $("#fob")

        if (sessionStorage.getItem("showConversionBanner") === "true") {
          showConversionBannerOnScroll()
        } else {
          $(window).on("scroll", showConversionBannerOnScroll)
        }

        $(".js-close", conversionBanner).on("click", function() {
          conversionBanner.removeClass("fob-is-visible")
          sessionStorage.removeItem("showConversionBanner")
          $(window).off("scroll", showConversionBannerOnScroll)
          Storage.setItem(STORAGE_KEY_CONVERSION_BANNER_HIDDEN, 'true', true)
        })
      }
    })
  })
})

fetchRouteItemsFavoriteState()
initRouteItems()
